import { render, staticRenderFns } from "./Ozluk.vue?vue&type=template&id=4b6235fc&scoped=true&"
import script from "./Ozluk.vue?vue&type=script&lang=js&"
export * from "./Ozluk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6235fc",
  null
  
)

export default component.exports